<template lang="pug">
  v-flex.DevelopmentContainer(xs12 v-if="showContainer")
    v-alert(:value="true" color="warning" outlined)
      b Development Only
      slot
</template>

<script>
export default {
  computed: {
    showContainer: () => process.env.NODE_ENV === "development"
  }
};
</script>
